module.exports = __webpack_public_path__ + "static/deep-medicine-34495856337fcf817e3afda90fd1e004.jpg";